module.exports = __webpack_public_path__ + "static/img/bjk_phsz_icon.png";